export const en = {
    "k_76a4befc": "CosId does not exist",
    "k_c6ccb06f": "[npm-loader] Initialization failed: {arg_0}",
    "k_b6620c6e": "❌ Unable to find a dependent package for the specified version: {arg_0}",
    "k_eb5afed0": "❌ Unable to find a dependent package for the specified version",
    "k_7eb7e72e": "❌ The requested dependency package version does not exist",
    "k_60012c69": "❌ The specified dependency cannot be found. Please check whether the package name is wrong",
    "k_cebc7377": "📦Installing dependency packages...",
    "k_a4b5e666": "❌ Dependent package installation failed",
    "k_9a6cb7bf": "⚡ Packaging dependent files...",
    "k_df14598c": "❌ Packaging of dependent files failed",
    "k_af282eed": "✅ Depends on updates to complete",
    "k_cca46ec5": "❌ Dependent update failed",
    "k_1662ff42": "Processing...",
    "k_ffc90dad": "Wuji blue",
    "k_c8f16779": "Dependency update failed, please check whether the external package name is wrong",
    "k_fc5e46fa": "Cannot find the dependency \"{arg_0}\". Please check whether the package name is wrong",
    "k_a995750d": "Dependent loading",
    "k_11b57fe4": "Dependency loading successfully",
    "k_d54f44cc": "Dependency updates..."
};
